var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 3.33333H8.33333C8.7 3.33333 9 3.03333 9 2.66667C9 2.3 8.7 2 8.33333 2H4.33333C3.6 2 3 2.6 3 3.33333V12.6667C3 13.4 3.6 14 4.33333 14H8.33333C8.7 14 9 13.7 9 13.3333C9 12.9667 8.7 12.6667 8.33333 12.6667H4.33333V3.33333Z",
    fill: "#BD161D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7667 7.76663L12.9067 5.90663C12.8603 5.859 12.8008 5.82629 12.7357 5.81268C12.6706 5.79907 12.603 5.80518 12.5414 5.83024C12.4799 5.8553 12.4272 5.89816 12.3901 5.95333C12.353 6.00851 12.3333 6.07349 12.3333 6.13997V7.3333H7.66667C7.3 7.3333 7 7.6333 7 7.99997C7 8.36663 7.3 8.66663 7.66667 8.66663H12.3333V9.85997C12.3333 10.16 12.6933 10.3066 12.9 10.0933L14.76 8.2333C14.8933 8.10663 14.8933 7.8933 14.7667 7.76663Z",
    fill: "#BD161D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.387c03806f4e4d44381f24c810a7ac93.svg";
export { ForwardRef as ReactComponent };